import styled from "@emotion/styled";
import { fontMerriweather } from "@product/scmp-sdk";

import { SeriesArticleSectionTag } from "~/components/article/article-render/series-article/section-tag";
import { BaseImage } from "~/components/common/base-image";
import { BaseLink } from "~/components/common/base-link";
import { ContentBookmark } from "~/components/content/content-bookmark";
import { ContentShareWidget } from "~/components/content/content-share-widget";
import { EntityLink } from "~/components/entity-link";

export type Props = {
  $backgroundImages: {
    $default: string;
    $desktopUp?: string;
    $tabletUp?: string;
  };
};

export const Container = styled.div<Props>`
  position: relative;

  color: #ffffff;
  text-align: center;

  background-image: url("${props => props.$backgroundImages.$default}");
  background-position: 50%;
  background-size: cover;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: auto;

    background-image: url("${props => props.$backgroundImages.$tabletUp}");
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    background-image: url("${props => props.$backgroundImages.$desktopUp}");
  }
`;

export const Background = styled.div``;

export const Content = styled.div`
  inset-block-start: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  block-size: 100%;
  padding-block: 36px;
  padding-inline: 57px;

  background: rgba(0, 0, 0, 0.4);

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 60px;
  }
`;

export const NewTag = styled.span`
  display: inline-block;

  padding-block: 3px;
  padding-inline: 6px;

  color: #000000;
  font-weight: 900;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 18px;
  text-transform: uppercase;

  background-color: #ffffff;
  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 4px;
    padding-inline: 8px;

    font-size: 20px;
    line-height: 25px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  inline-size: 300px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 502px;
  }
`;

export const StyledSeriesArticleSectionTag = styled(SeriesArticleSectionTag)`
  display: inline-block;

  margin-block-end: 24px;
  padding-block: 3px;
  padding-inline: 6px;

  color: #000000;
  font-weight: 900;
  font-size: 14px;
  font-family: ${fontMerriweather};
  line-height: 18px;

  background-color: #ffca05;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 4px;
    padding-inline: 8px;

    font-size: 20px;
    line-height: 25px;
  }
`;

export const Headline = styled.div`
  max-inline-size: 640px;
  margin-block-end: 20px;

  font-weight: 200;
  font-size: 36px;
  font-family: ${fontMerriweather};
  line-height: 45px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 60px;
    line-height: 72px;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;

  max-inline-size: 500px;
  padding-block: 20px 20px;

  font-size: 16px;
  line-height: 22px;

  border: 1px solid #ffffff;
  border-width: 1px 0 0;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 28px 20px;
  }
`;

export const Updated = styled.div`
  display: flex;
  flex-direction: column;

  font-size: 14px;
  line-height: 16px;
`;

export const Time = styled.div`
  margin-block-end: 31px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;

  block-size: 21px;

  overflow: hidden;
`;

export const StyledEntityLink = styled(EntityLink)``;

export const StyledBaseImage = styled(BaseImage)`
  object-position: 50% 50%;
`;

export const Bookmark = styled.div`
  margin-inline-start: 10px;
  padding-inline-start: 20px;
  border-inline-start: 1px solid #ffffff;
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  inline-size: 18px;
  block-size: 21px;
  padding: 0;

  path {
    fill: #ffffff;
  }
`;

export const StyledContentShareWidget = styled(ContentShareWidget)`
  display: flex;
  div {
    inline-size: 40px;
    block-size: 21px;
    padding: 0;
    padding-inline: 10px;
  }
`;

export const StyledBaseLink = styled(BaseLink)``;
